import { ProductButton, BundleItems, BundleItemRow, BundleItemCell } from './styles'

ProductButton.BundleItems = BundleItems
ProductButton.BundleItemRow = BundleItemRow
ProductButton.BundleItemCell = BundleItemCell

export default ProductButton
